module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.pages), function(page) {
    return _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": 'work/' + page.slug
      }
    }, [_vm._v(_vm._s(page.title))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(page.slug))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(page.position))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("timestampToDate")(page.updated)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(page.published))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:top",
        value: ('Clone'),
        expression: "'Clone'",
        arg: "top"
      }],
      staticClass: "action",
      on: {
        "click": function($event) {
          _vm.clonePage(page)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-clone",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('td', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:top",
        value: ('Edit'),
        expression: "'Edit'",
        arg: "top"
      }],
      staticClass: "action",
      on: {
        "click": function($event) {
          _vm.editPage(page)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('td', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:top",
        value: ('Remove'),
        expression: "'Remove'",
        arg: "top"
      }],
      staticClass: "action",
      class: {
        disabled: page.locked
      },
      on: {
        "click": function($event) {
          _vm.removePage(page)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('strong', [_vm._v("Pages")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Slug")]), _vm._v(" "), _c('th', [_vm._v("Position")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Updated")]), _vm._v(" "), _c('th', [_vm._v("Published")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a7f57f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/back/home/PageList.vue
// module id = 267
// module chunks = 1